var tabsItem = 'fx_2d2fb1e5_qq1dk54';
var tabsItemHorizontalGap = 'var(--fx_2d2fb1e5_qq1dk51)';

export { tabsItem, tabsItemHorizontalGap };
//# sourceMappingURL=item.vanilla.mjs.map
